import { defaultPinTheme, PinViewerStatic } from '@lessonup/pin-renderer';
import { Pin, PinTheme } from '@lessonup/pins-shared';
import { Grid, LoaderSpinner, spacing, styled, Thumb } from '@lessonup/ui-components';
import React from 'react';

interface ThemeListViewProps {
  loading: boolean;
  themes: PinTheme[];
  currentPinTheme: PinTheme;
  strippedPin: Pin;
  pinWidth: number;
  onThemeSelect: (theme: PinTheme | null) => void;
}

export const ThemeListView: React.FC<ThemeListViewProps> = ({
  loading,
  themes,
  currentPinTheme,
  strippedPin,
  pinWidth,
  onThemeSelect,
}) => {
  if (loading) {
    return (
      <StyledLoaderWrapper>
        <LoaderSpinner />
      </StyledLoaderWrapper>
    );
  }

  return (
    <StyledScrollableContent>
      <StyledLayoutList cols={2} gap={spacing.size16} as="ul">
        <li key={defaultPinTheme.id}>
          <Thumb
            thumbType="mediumCaption"
            number={1}
            onClick={() => onThemeSelect(null)}
            isActive={defaultPinTheme.id === currentPinTheme.id}
            caption={defaultPinTheme.name}
          >
            <ThumbPaneWrapper>
              <PinViewerStatic pin={strippedPin} width={pinWidth} isThumb pinTheme={defaultPinTheme} />
              <ThumbPane />
            </ThumbPaneWrapper>
          </Thumb>
        </li>
        {themes.map((pinTheme, index) => {
          const isActive = pinTheme.id === currentPinTheme.id;
          return (
            <li key={pinTheme.id}>
              <Thumb
                thumbType="mediumCaption"
                number={index + 2}
                onClick={() => onThemeSelect(pinTheme)}
                isActive={isActive}
                caption={pinTheme.name}
              >
                <ThumbPaneWrapper>
                  <PinViewerStatic pin={strippedPin} width={pinWidth} isThumb pinTheme={pinTheme} />
                  <ThumbPane />
                </ThumbPaneWrapper>
              </Thumb>
            </li>
          );
        })}
      </StyledLayoutList>
    </StyledScrollableContent>
  );
};

const StyledLoaderWrapper = styled.div`
  height: 400px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledScrollableContent = styled.div`
  flex: 1;
  overflow-y: auto;
  scrollbar-gutter: stable;
`;

const StyledLayoutList = styled(Grid)`
  margin: 0;
  padding: ${spacing.size12};
  list-style: none;
`;

const ThumbPaneWrapper = styled.div`
  position: relative;
`;

const ThumbPane = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;
